import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { advanceParamCheck } from "../../utils";

export interface ChooseImageOption extends Partial<GeneralInvokeOption> {
  count?: number;
  sizeType?: Array<String>;
  sourceType?: Array<String>;
  invalidParamObj?: '';
}

// 拍照或上传
export function chooseImage(option: ChooseImageOption) {
  const checkOptions = {
    sourceType: {
      optional: true, // 可选参数
      checkSubEleType: true, // 检查子项类型
      range: ['album', 'camera'] // 值范围
    },
    sizeType: {
      optional: true, // 可选参数
      range: ['original', 'compressed'] // 值范围
    }
  };
  if (advanceParamCheck(APINames.Native.CHOOSE_IMAGE, option, { sourceType: [''], sizeType: [''] }, checkOptions)) {
    const fixedOption = Object.assign(
      {
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera']
      },
      option
    );
    return MacleJSBridge.beforeInvoke(
      APINames.Native.CHOOSE_IMAGE, 
      fixedOption);
  }
  return option.invalidParamObj;
}

